import { DateQueryDateTypeEnum } from './date-query-date-type.enum';

export enum DateFacetTypesEnum {
    indexed = 'INDEXED',
    created = 'CREATED',
    saved = 'SAVED',
    edited = 'EDITED'
}

export const dateTypeToDateFacetMap: Map<DateQueryDateTypeEnum, DateFacetTypesEnum> = new Map([
    [ DateQueryDateTypeEnum.PUBLISHED, DateFacetTypesEnum.created ],
    [ DateQueryDateTypeEnum.HARVESTED, DateFacetTypesEnum.indexed ],
    [ DateQueryDateTypeEnum.SAVED, DateFacetTypesEnum.saved ],
    [ DateQueryDateTypeEnum.EDITED, DateFacetTypesEnum.edited ]
]);
